import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import PageTitle from '../../components/PageTitle/PageTitle';
import Loader from '../../components/Loader/LoaderView';
import FormInputLabel from '../../components/FormInputLabelView';
import {
  Grid,
  withStyles,
  TextField,
  Button,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  IconButton,
  FormHelperText,
  MenuItem,
  Select,
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { clearLocalStorage, setSelectTenant } from '../../utils/common';
import CustomFooter from '../../components/Table/CustomFooter';
import { tenantInfo } from '../../utils/tenantInformation';

class AreasPage extends Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.state = {
      tenants: [],
      loading: false,
      data: {
        tenantId: null,
        name: '',
      },
      selectRouterList: [],
      routerList: {
        data: [],
        pagination: {},
      },
      errorField: {
        name: false,
        tenantId: false,
      },
      path: '',
      routersInBuilding: [],
      routersOutOfBuilding: [],
      limit: 100,
    };
  }

  async componentDidMount() {
    const tenants = tenantInfo();
    this.setState({ tenants });

    // const { tenantIds } = this.props.area.toJS();
    const { id } = this.props.match.params;
    const path = this.props.match.path.replace('/app/areas/:id/', '');
    if (path === 'edit' || path === 'view') {
      await this.initselectselectRouterList(id);
    } else {
      const tenantIds = localStorage.getItem('select_tenant') ? [+localStorage.getItem('select_tenant')] : null;
      if (tenantIds) {
        this.setState({ data: { tenantId: tenantIds[0] } });
        await this.props.router.getRouterForArea([], 0, this.state.limit, null, null, null, tenantIds);
      }
      // const tenants = tenantInfo();
      // if (tenants.length === 1) {
      //   tenants.forEach((g) => {
      //     this.setState({ data: { tenantId: g.id } });
      //   });
      //   await this.props.router.getRouterForArea([], 0, this.state.limit, null, null, null, [this.state.data.tenantId]);

      // } else if (tenantIds && tenantIds.length === 1) {
      //   tenantIds.forEach((id) => {
      //     this.setState({ data: { tenantId: id } });
      //   });
      //   await this.props.router.getRouterForArea([], 0, this.state.limit, null, null, null, tenantIds);
      // }
    }

    this.setState({ path });
  }

  goBack() {
    this.props.area.setAction('action', true);
    this.props.history.goBack();
  }

  async initselectselectRouterList(id) {
    await this.props.area.getAreaById(id);

    const { areas, routersInBuilding, routersOutOfBuilding, routerList, routerIds } = this.props.area.toJS();
    if (areas.length > 0) {
      const tenantId = areas[0].tenantId;
      await this.props.router.setAddRouter(routerList, [tenantId]);
      const placeList = await this.props.router.getRouterPlaces(routerIds);
      let listRouterInBuilding = (routersInBuilding || []).map((val) => {
        return {
          id: val.id ? val.id : '',
          serial: val.serial,
          label: this.getLabelName(val, placeList),
        };
      });
      let listRouterOutOfBuilding = (routersOutOfBuilding || []).map((val) => {
        return {
          id: val.id ? val.id : '',
          serial: val.serial,
          label: this.getLabelName(val, placeList),
        };
      });

      this.setState({
        routersInBuilding: listRouterInBuilding,
        routersOutOfBuilding: listRouterOutOfBuilding,
        data: {
          tenantId,
          name: areas[0].name,
          id: areas[0].id,
        },
      });
    }
  }

  getLabelName = (data, placeList) => {
    let place = placeList.find((item) => item.routerId === data.id);
    return place ? `${place.place} (${data.serial})` : `${data.serial} (${data.serial})`;
  };

  onClickAddRouter = (task) => {
    let { selectRouterList, routersInBuilding, routersOutOfBuilding, data } = this.state;
    (selectRouterList || []).forEach((data) => {
      if (task === 'inBuilding') {
        routersInBuilding.push(data);
      }
      if (task === 'outBuilding') {
        routersOutOfBuilding.push(data);
      }
    });
    this.props.router.setAddRouter(selectRouterList, [data.tenantId]);

    this.setState({
      routersInBuilding,
      routersOutOfBuilding,
      selectRouterList: [],
    });
  };

  handleChange = async (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState((prevState) => {
      prevState.data[name] = value;
      return prevState;
    });
    if (name === 'tenantId') {
      this.setState({
        routersInBuilding: [],
        routersOutOfBuilding: [],
        selectRouterList: [],
      });
      await this.props.router.setDataForArea('search', null, false);
      await this.props.router.getRouterForArea([], 0, this.state.limit, null, null, null, [value]);

      await this.props.area.setData('tenantIds', [value]);
      setSelectTenant([value]);
    }
  };

  handleToggle(val) {
    let selectRouterList = this.state.selectRouterList;
    const checkSelected = selectRouterList.find((data) => data.id === val.id);

    if (checkSelected) {
      selectRouterList = selectRouterList.filter((data) => data.id !== val.id);
    } else {
      selectRouterList.push(val);
    }
    this.setState({ selectRouterList });
  }

  handleDeleteRouter(val, task) {
    let { routersInBuilding, routersOutOfBuilding, data } = this.state;

    if (task === 'inBuilding') {
      routersInBuilding = routersInBuilding.filter((data) => data.id !== val.id);
    }
    if (task === 'outBuilding') {
      routersOutOfBuilding = routersOutOfBuilding.filter((data) => data.id !== val.id);
    }
    this.props.router.setDeleteRouter(val, [data.tenantId]);
    this.setState({ routersInBuilding, routersOutOfBuilding });
  }

  handleSave = async (data) => {
    let { routersInBuilding, routersOutOfBuilding } = this.state;
    routersInBuilding = routersInBuilding.map((val) => {
      return {
        id: val.id,
        serial: val.serial,
      };
    });
    routersOutOfBuilding = routersOutOfBuilding.map((val) => {
      return {
        id: val.id,
        serial: val.serial,
      };
    });
    if (this.validate()) {
      this.state.path === 'edit'
        ? this.handleEditRouterInArea(data, routersInBuilding, routersOutOfBuilding)
        : this.handleCreatRouterInArea(data, routersInBuilding, routersOutOfBuilding);
    }
  };

  handleEditRouterInArea = async (data, routersInBuilding, routersOutOfBuilding) => {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('edit_area')}?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: `${t('edit')}`,
      cancelButtonText: `${t('cancel')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.area.updateArea(data, routersInBuilding, routersOutOfBuilding);
          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('update_success')}`,
              type: 'success',
            }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                this.props.area.setAction('action', true);
                this.props.history.push('../../areas');
              } else {
                Swal.fire({
                  html: `<h4>${t('failed_to_update')}`,
                  type: 'error',
                });
              }
            });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else if (e.statusCode === 400) {
            const msg = e.error.message || t('failed_to_update');
            Swal.fire({ html: `<h4>${msg}`, type: 'error' });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
          }
        }
      }
    });
  };

  handleCreatRouterInArea = async (data, routersInBuilding, routersOutOfBuilding) => {
    const { t } = this.props;
    try {
      const result = await this.props.area.createArea(data, routersInBuilding, routersOutOfBuilding);
      if (result.statusCode === 200) {
        Swal.fire({
          html: `<h4>${t('assign_success')}`,
          type: 'success',
        }).then(async (resultSuccess) => {
          if (resultSuccess.value) {
            this.props.area.getAreas(0, 15);
            this.props.history.push('../areas');
          }
        });
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_assign')}`, type: 'error' });
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else if (e.statusCode === 400) {
        const msg = e.error.message || t('failed_to_create');
        Swal.fire({ html: `<h4>${msg}`, type: 'error' });
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
      }
    }
  };

  validate() {
    const { data } = this.state;
    if (!data.name || !data.tenantId) {
      let checkTenantId = !data.tenantId ? true : false;
      let checkName = !data.name ? true : false;
      this.setState({
        errorField: {
          tenantId: checkTenantId,
          name: checkName,
        },
      });
      return false;
    } else {
      this.setState({
        errorField: {
          tenantId: false,
          name: false,
        },
      });
    }
    return true;
  }

  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          name: false,
        },
      });
    }
    if (key === 'tenantId') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          tenantId: false,
        },
      });
    }
  }

  handleSearch = async (task, value) => {
    const { data } = this.state;
    this.props.router.setDataForArea('offset', 0, false);
    this.props.router.setDataForArea('limit', this.state.limit, false);
    this.props.router.setDataForArea('tenantIds', [data.tenantId], false);
    await this.props.router.setDataForArea(task, value);
  };

  handleChangeRowsPerPage = (value) => {
    this.props.router.setDataForArea('limit', value);
  };

  handleChangePage = async (value) => {
    await this.props.router.setDataForArea('offset', value * this.state.limit);
  };

  renderFormCreate() {
    const { classes, t } = this.props;
    const { data, selectRouterList, path, routersInBuilding, routersOutOfBuilding, tenants } = this.state;
    const { routerInArea, loading, search } = this.props.router.toJS();
    const count = routerInArea.data ? routerInArea.pagination.count : 0;
    const page = routerInArea.data ? routerInArea.pagination.page - 1 : 0;
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          {path === 'edit' ? <PageTitle title={t('edit_area')} /> : <PageTitle title={t('create_area')} />}
          <Grid container spacing={16} className={classes.wrapContain}>
            {/* <Grid container spacing={16} style={{ marginTop: "-30px" }}> */}
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId || ' '}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                  disabled={path === 'edit' ? true : false}
                >
                  <MenuItem fullwidth='true' key={9999999} value={' '}>
                    {t('please_select_tenant')}
                  </MenuItem>
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.tenantId : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={6} sm={6}>
              <FormInputLabel label={t('routers_list')} />
            </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={6} sm={6}>
              <TextField
                required
                id='search'
                name='search'
                fullWidth
                value={search || ''}
                onChange={(e) => this.handleSearch('search', e.target.value)}
                variant='outlined'
                margin='dense'
                placeholder='Search Router'
              />
            </Grid>
            <Grid item xs={6} sm={6} />

            <Grid item xs={6} sm={6}>
              <List className={classes.muitiSelect}>
                {(routerInArea.data || []).map((val) => {
                  return (
                    <ListItem key={val.id} role={undefined} dense button onClick={() => this.handleToggle(val)}>
                      <ListItemIcon style={{ marginRight: '0px' }}>
                        <Checkbox
                          style={{ padding: '0px' }}
                          color='primary'
                          edge='start'
                          checked={selectRouterList.find((data) => data.id === val.id) ? true : false}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{
                            'aria-labelledby': `checkbox-list-label-${val.id}`,
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        className={classes.labelCheckBox}
                        id={`checkbox-list-label-${val.id}`}
                        primary={`${val.label}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
              <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', right: '-30px' }}>
                  <CustomFooter
                    count={count}
                    page={page}
                    rowsPerPage={this.state.limit}
                    rowsPerPageOptions={[]}
                    changeRowsPerPage={this.handleChangeRowsPerPage}
                    changePage={this.handleChangePage}
                  />
                </div>
              </div>
            </Grid>

            <Grid item xs={6} sm={6}>
              <Grid container item sm={12} className={classes.gridMargin}>
                <div className={classes.boxAdd}>
                  <Button
                    variant='contained'
                    color='primary'
                    className={classes.btnAdd}
                    onClick={() => this.onClickAddRouter('inBuilding')}
                  >
                    {t('add')}
                    <ArrowRightIcon />
                  </Button>
                </div>
                <Grid item xs={10} sm={10}>
                  <FormInputLabel label={t('routers_in_building')} />
                  <List className={classes.boxSelect}>
                    {routersInBuilding.map((val) => {
                      return (
                        <ListItem
                          key={val.id}
                          role={undefined}
                          dense
                          button
                          onClick={() => this.handleDeleteRouter(val, 'inBuilding')}
                        >
                          <ListItemIcon style={{ marginRight: '0px' }}>
                            <IconButton style={{ padding: '0px' }} edge='end' aria-label='delete'>
                              <ClearIcon />
                            </IconButton>
                          </ListItemIcon>
                          <ListItemText
                            className={classes.labelCheckBox}
                            id={`select-list-label-${val.id}`}
                            primary={`${val.label}`}
                          />
                        </ListItem>
                      );
                    })}
                  </List>
                </Grid>
              </Grid>

              <Grid container item sm={12} className={classes.gridMargin}>
                <div className={classes.boxAdd}>
                  <Button
                    variant='contained'
                    color='primary'
                    className={classes.btnAdd}
                    onClick={() => this.onClickAddRouter('outBuilding')}
                  >
                    {t('add')}
                    <ArrowRightIcon />
                  </Button>
                </div>
                <Grid item xs={10} sm={10}>
                  <FormInputLabel label={t('routers_out_building')} />
                  <List className={classes.boxSelect}>
                    {routersOutOfBuilding.map((val) => {
                      return (
                        <ListItem
                          key={val.id}
                          role={undefined}
                          dense
                          button
                          onClick={() => this.handleDeleteRouter(val, 'outBuilding')}
                        >
                          <ListItemIcon style={{ marginRight: '0px' }}>
                            <IconButton style={{ padding: '0px' }} edge='end' aria-label='delete'>
                              <ClearIcon />
                            </IconButton>
                          </ListItemIcon>
                          <ListItemText
                            className={classes.labelCheckBox}
                            id={`select-list-label-${val.id}`}
                            primary={`${val.label}`}
                          />
                        </ListItem>
                      );
                    })}
                  </List>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            {path === 'edit' ? (
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleSave(data)}
                  className={classes.button}
                >
                  {t('edit')}
                </Button>
              </div>
            ) : (
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleSave(data)}
                  className={classes.button}
                >
                  {t('save')}
                </Button>
              </div>
            )}
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderView() {
    const { classes, t } = this.props;
    const { tenants, data, selectRouterList, routersInBuilding, routersOutOfBuilding } = this.state;
    const { routerInArea, loading } = this.props.router.toJS();
    const count = routerInArea.data ? routerInArea.pagination.count : 0;
    const page = routerInArea.data ? routerInArea.pagination.page - 1 : 0;

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('view_area')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            {/* <Grid container spacing={16} style={{ marginTop: "-30px" }}> */}
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId || ' '}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                  disabled
                >
                  <MenuItem fullwidth='true' key={9999999} value={' '}>
                    {t('please_select_tenant')}
                  </MenuItem>
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                variant='outlined'
                margin='dense'
                disabled
              />
            </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={6} sm={6}>
              <FormInputLabel label={t('routers_list')} disabled />
            </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={6} sm={6}>
              <List className={classes.muitiSelect}>
                {(routerInArea.data || []).map((val) => {
                  return (
                    <ListItem key={val.id} role={undefined} dense button disabled>
                      <ListItemIcon style={{ marginRight: '0px' }}>
                        <Checkbox
                          style={{ padding: '0px' }}
                          color='primary'
                          edge='start'
                          checked={selectRouterList.find((data) => data.id === val.id) ? true : false}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{
                            'aria-labelledby': `checkbox-list-label-${val.id}`,
                          }}
                          disabled
                        />
                      </ListItemIcon>
                      <ListItemText
                        className={classes.labelCheckBox}
                        id={`checkbox-list-label-${val.id}`}
                        primary={`${val.label}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
              <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', right: '-30px' }}>
                  <CustomFooter
                    count={count}
                    page={page}
                    rowsPerPage={this.state.limit}
                    rowsPerPageOptions={[]}
                    changeRowsPerPage={this.handleChangeRowsPerPage}
                    changePage={this.handleChangePage}
                  />
                </div>
              </div>
            </Grid>

            <Grid item xs={6} sm={6}>
              <Grid container item sm={12} className={classes.gridMargin}>
                <div className={classes.boxAdd}>
                  <Button
                    variant='contained'
                    color='primary'
                    className={classes.btnAdd}
                    onClick={() => this.onClickAddRouter('inBuilding')}
                    disabled
                  >
                    {t('add')}
                    <ArrowRightIcon />
                  </Button>
                </div>
                <Grid item xs={10} sm={10}>
                  <FormInputLabel label={t('routers_in_building')} />
                  <List className={classes.boxSelect}>
                    {routersInBuilding.map((val) => {
                      return (
                        <ListItem key={val.id} role={undefined} dense button disabled>
                          <ListItemIcon style={{ marginRight: '0px' }}>
                            <IconButton style={{ padding: '0px' }} edge='end' aria-label='delete'>
                              <ClearIcon />
                            </IconButton>
                          </ListItemIcon>
                          <ListItemText
                            className={classes.labelCheckBox}
                            id={`select-list-label-${val.id}`}
                            primary={`${val.label}`}
                          />
                        </ListItem>
                      );
                    })}
                  </List>
                </Grid>
              </Grid>

              <Grid container item sm={12} className={classes.gridMargin}>
                <div className={classes.boxAdd}>
                  <Button variant='contained' color='primary' className={classes.btnAdd} disabled>
                    {t('add')}
                    <ArrowRightIcon />
                  </Button>
                </div>
                <Grid item xs={10} sm={10}>
                  <FormInputLabel label={t('routers_out_building')} />
                  <List className={classes.boxSelect}>
                    {routersOutOfBuilding.map((val) => {
                      return (
                        <ListItem key={val.id} role={undefined} dense button disabled>
                          <ListItemIcon style={{ marginRight: '0px' }}>
                            <IconButton style={{ padding: '0px' }} edge='end' aria-label='delete'>
                              <ClearIcon />
                            </IconButton>
                          </ListItemIcon>
                          <ListItemText
                            className={classes.labelCheckBox}
                            id={`select-list-label-${val.id}`}
                            primary={`${val.label}`}
                          />
                        </ListItem>
                      );
                    })}
                  </List>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <div className={classes.buttons}>
              <Button className={classes.button} onClick={this.goBack}>
                {t('back')}
              </Button>
            </div>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  render() {
    const path = this.props.match.path.replace('/app/areas/:id/', '');
    let result;
    switch (path) {
      case 'edit':
        result = this.renderFormCreate();
        break;
      case 'view':
        result = this.renderView();
        break;
      default:
        result = this.renderFormCreate();
        break;
    }
    return result;
  }
}

const styles = (theme) => ({
  labelCheckBox: {
    paddingLeft: '5px',
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      overflow: 'hidden',
      padding: '0',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '1',
      WebkitBoxOrient: 'vertical',
    },
  },
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: '10px 20px 2px 20px',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: '5px',
  },
  muitiSelect: {
    // marginTop: "5px",
    marginBottom: '5px',
    borderRadius: '5px',
    borderStyle: 'solid',
    borderColor: 'gray',
    borderWidth: '1px',
    height: 400,
    position: 'relative',
    overflow: 'auto',
  },
  muitiSelectNoBorder: {
    marginTop: '35px',
    marginBottom: '35px',
  },
  boxSelect: {
    // marginTop: "15px",
    marginBottom: '35px',
    borderRadius: '5px',
    borderStyle: 'solid',
    borderColor: 'gray',
    borderWidth: '1px',
    // maxHeight: 200,
    position: 'relative',
    overflow: 'auto',
    height: 165,
  },
  boxAdd: {
    textAlign: 'center',
    marginTop: '50px',
    marginBottom: '35px',
    marginRight: '15px',
    height: 165,
  },
  gridMargin: {
    marginTop: '-30px',
  },
  btnAdd: {
    width: 60,
    paddingLeft: '22px',
    marginTop: 60,
  },
});
export const page = inject('router', 'area')(observer(AreasPage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
